import React, { Suspense, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Panel, Tab, Col, Row, Button } from 'react-bootstrap';
import _ from 'lodash';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import Permission from '../../components/Permission/Permission';

import { useFranchiseRolesStore } from '../../store/providers/FranchiseRoles';
import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import Spinner from '../../components/Spinner/Spinner';
import { columns, sorting } from './FranchisePermissionsSchema';
import * as constants from '../../constants';
import { navigate } from 'raviger';
import { modifyToInstance } from '../../lib/Formatter';

const BaseList = React.lazy(() => import('../../components/Lists/BaseList/BaseList'));
const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));

function FranchiseRole(props) {
    const dispatch = useDispatch();

    const { selectRecord, deleteRolePermission, createRolePermission, listPermissionsRecords, data } = useFranchiseRolesStore();

    const [isMounted, setIsMounted] = useState(false);
    const [roleInfo, setRoleInfo] = useState(false);
    const [listPermissionsData, setListPermissionsData] = useState([]);
    const [listPermissionsAll, setListPermissionsAll] = useState([]);
    const [listPermissionsAssigned, setListPermissionsAssigned] = useState([]);
    const [listPermissionsRetrieved, setListPermissionsRetrieved] = useState(false);

    const [isBusy, setIsBusy] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
  
    const pagePermission = constants.PERMISSION_SETTINGS_FRANCHISEROLEMANAGEMENT;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);


    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);

        dispatch(breadcrumbAddRoute({ key: 'franchise-role', path: '/userroles', text: 'Edit User Role Permissions' }));
        if (!_.isEmpty(props.roleId)) {
            selectRecord({ roleId: props.roleId });
            listPermissionsRecords();
        }
        setIsMounted(true);
    }, [isMounted, hasPermission, dispatch, props.roleId, selectRecord, roleInfo]);

    useEffect(() => {
        if (isMounted && !_.isEmpty(data) && !_.isEmpty(data.body)) {
            if ((data.scope === 'select' || data.scope === 'new') && data.status === 'success') {
                setRoleInfo(data.body);
                setListPermissionsAssigned(data.body.assignedPermissions);
                setListPermissionsRetrieved(true);
            }

            if (data.status === 'success' && data.scope === 'listperms') {
                setListPermissionsData(data.body);
            }

            setIsBusy(data.status === 'processing' && (data.scope === 'delete' || data.scope === 'list' || data.scope === 'create'));
        }

    }, [props, data, isMounted, roleInfo]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    useEffect(() => {
        if (listPermissionsData.length > 0 && listPermissionsRetrieved) {
            let allPermissions = listPermissionsData;
            let assignedPermissions = [];
            if(listPermissionsAssigned.length > 0) {
                Object.entries(listPermissionsAssigned).forEach((entry) => {
                    const [, value] = entry;
                    value.enabled = true;
                    assignedPermissions.push(value);         
                });
            }
            for(var i = 0, l = allPermissions.length; i < l; i++) {
                for(var j = 0, ll = assignedPermissions.length; j < ll; j++) {
                    if(allPermissions[i].id === assignedPermissions[j].id) {
                        allPermissions.splice(i, 1, assignedPermissions[j]);
                        break;
                    }
                }
            }
            setListPermissionsAll(allPermissions);
        }
    }, [listPermissionsData, listPermissionsAssigned]);

    const goBackHandler = () => {
        navigate('/userroles');
    };

    const listChanged = (_id, value, item, _row) => {
        //setIsBusy(true);
        if(_id == 'canEdit'){
            updateCanEditStatus(_row, value, true);
        } else if (_id == 'enabled') {
            updateEnabledStatus(_row, value, true);
        }
    }

    let updateEnabledStatus = (row, value, isCheckboxEvent = false) => {
        if(row.enabled){
            let allPermissions = listPermissionsAll.map(obj => {
                if (obj.id === row.id) {
                  return {...obj, enabled: false};
                }
                return obj;
            });
            setListPermissionsAll(allPermissions);
            deleteRolePermission({ permissionId: row.id, roleId: roleInfo.id});
        } else {
            let allPermissions = listPermissionsAll.map(obj => {
                if (obj.id === row.id) {
                  return {...obj, enabled: true};
                }
                return obj;
            });
            setListPermissionsAll(allPermissions);
            createRolePermission({ ...row, roleId: roleInfo.id, permissionId: row.id });
        }
    };

    let updateCanEditStatus = (row, value, isCheckboxEvent = false) => {
        if(row.enabled){
            let allPermissions = listPermissionsAll.map(obj => {
                if (obj.id === row.id) {
                    return {...obj, canEdit: !row.canEdit};
                }
                return obj;
            });

            setListPermissionsAll(allPermissions);
            createRolePermission({roleId: roleInfo.id, permissionId: row.id, canEdit: !row.canEdit});            
        } else {
            setIsBusy(false);
            alert("You  must enable this permission before allowing edit ablility.")
        }
    };

    return (
        <>
            <SideMenu activeKey="settings" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isMounted &&
                    <>
                        {
                            (isLoading) && <Spinner text="Loading Instance Role Permissions..." />
                        }
                        {
                            !isLoading && 
                            <Suspense fallback={<Spinner text="Loading..." />}>
                                {roleInfo && listPermissionsAll.length > 0 &&
                                    <div style={{ paddingRight: '15px' }}>
                                        <PageHeader title={modifyToInstance(roleInfo.name) + ' Permissions'} />
                                        <Panel>
                                            <Panel.Body>
                                                <Tab.Container id="sfsf" defaultActiveKey="general" >
                                                    <Row className="clearfix">
                                                        <Col sm={12}>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <Button bsStyle="default" onClick={() => goBackHandler()} className="button-group-margin pull-right" disabled={isBusy}>
                                                                        <i className="fa fa-undo button-icon"></i>
                                                                        Back
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <div style={{ paddingRight: '15px' }}>
                                                                        <h4>PERMISSIONS</h4>
                                                                            <Panel>
                                                                                <Panel.Body>
                                                                                    <BaseList
                                                                                        compType="Permission"
                                                                                        keyField="id"
                                                                                        listData={listPermissionsAll}
                                                                                        isBusy={isBusy}
                                                                                        sorting={sorting}
                                                                                        columns={columns}
                                                                                        hideCopy={true}
                                                                                        hideRefresh={true}
                                                                                        hidePrint={true}
                                                                                        hideFilter={true}
                                                                                        hideDelete={true}
                                                                                        hasCheckbox={true}
                                                                                        hideAdd={true}
                                                                                        hideEdit={true}
                                                                                        hidePagination={true}
                                                                                        showActions={false}
                                                                                        permissionEdit={canEdit}
                                                                                        changed={(id, value, item, row) => listChanged(id, value, item, row)}
                                                                                    />
                                                                                </Panel.Body>
                                                                            </Panel>
                                                                    </div>
                                                                </Col>
                                                                
                                                            </Row>
                                                            <hr />
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <div className="form-action-buttons">
                                                                        <Button bsStyle="default" onClick={() => goBackHandler()} className="button-group-margin" disabled={isBusy}>
                                                                            <i className="fa fa-undo button-icon"></i>
                                                                            Back
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Tab.Container>
                                            </Panel.Body>
                                        </Panel>
                                    </div>
                                }
                            </Suspense>

                        }
                    </>
                }
            </div>
        </>
    );
}

export default withAuthentication(withLayout(FranchiseRole));